import { Inject } from '@odinjs/odin';

import { CONFIRMATION_FIELD_VALID_PW, confirmationFieldValidatorPassword, Endpoint, FOUNDATION_ROUTES, passwordValidator, ProviderAccreditationConfigurationService, PW_VALIDATOR, ToastServiceProviderAccreditation } from '@philips-emr/hpms-provider-accreditation-commons';
import { ButtonAPI, FieldAPI, FormAPI, ImageAPI, PanelAPI, TextAPI } from '@philips-emr/tws-components';
import Controller, { OnClick, OnKeyDown, OnMount, OnValidate } from '@philips-emr/tws-core/lib/client';
import { ValidateEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService, MessageService } from '@philips-emr/tws-core/lib/services';
import { HttpError } from '@philips-emr/tws-core/lib/services/http-service';

import { NewPwAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.NEW_PW })
export default class NewPwController extends BaseController {

  @Inject(Aliases.BUTTON_CREATE_NEW_PW)
  private buttonConfirmNewPw: ButtonAPI;
  @Inject(Aliases.FIELD_CONFIRM_NEW_PW)
  private fieldConfirmPw: FieldAPI;
  @Inject(Aliases.FORM_NEW_PW)
  private formNewPw: FormAPI;
  @Inject(Aliases.PANEL_LOADER)
  private panelLoader: PanelAPI;
  @Inject(Aliases.PANEL_ACTIONS)
  private panelActions: PanelAPI;
  @Inject(Aliases.TEXT_MESSAGE)
  private textMessage: TextAPI;
  @Inject(Aliases.PANEL_SUCCESS)
  private panelSuccess: PanelAPI;
  @Inject(Aliases.PANEL_SCREEN)
  private panelScreen: PanelAPI;
  @Inject(Aliases.FIELD_NEW_PW)
  private fieldNewPw: FieldAPI;

  @OnMount(Aliases.IMAGE_LOGO)
  onMountMain(event: MouseEvent): void {
    const api = event.target as unknown as ImageAPI;
    ProviderAccreditationConfigurationService.getConfigurationData()
      .then(data => api.setSrc(data.dsUrlLogoHeaderLogin as string))
      .catch(() => ToastServiceProviderAccreditation.error(MessageService.translate('pa.error-process-request')));
  }

  @OnValidate(Aliases.FORM_NEW_PW)
  onValidadeForm(event: ValidateEvent): void {
    this.buttonConfirmNewPw.setEnabled(event.valid);
  }

  @OnMount(Aliases.FORM_NEW_PW)
  onMountForm(): void {
    this.fieldConfirmPw.addLocalValidator(CONFIRMATION_FIELD_VALID_PW, (value) => {
      const confirmationValue = this.formNewPw.getRecord()['dsNewPw'];
      return confirmationFieldValidatorPassword(value, confirmationValue);
    });
    this.fieldNewPw.addLocalValidator(PW_VALIDATOR, passwordValidator);
  }

  @OnClick(Aliases.BUTTON_CREATE_NEW_PW)
  onClickCreateNewPw(): void {
    if (this.formNewPw.validate()) {
      this.panelLoader.setVisible(true);
      this.panelActions.setVisible(false);
      const { hash } = this.historyService.getCurrentRouteParams();
      const body = { ...this.formNewPw.getRecord() };
      HttpService.post(Endpoint.POST.NEW_PASSWORD, { hash }, { body })
        .then(() => {
          this.panelScreen.setVisible(false);
          this.panelSuccess.setVisible(true);
        })
        .catch(error => {
          this.panelLoader.setVisible(false);
          this.panelActions.setVisible(true);
          this.handleLoginError(error);
        });
    }
  }

  @OnClick(Aliases.BUTTON_ACCESS_ACCOUNT)
  onClickAccessAccount(): void {
    this.historyService.push(FOUNDATION_ROUTES.LOGIN);
  }

  @OnKeyDown({ target: [Aliases.INPUT_NEW_PW, Aliases.INPUT_CONFIRM_NEW_PW] })
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.onClickCreateNewPw();
    }
  }

  private handleLoginError(error: HttpError): void {
    if (error.response) {
      error.response.json()
        .then(() => this.textMessage.setValue('pa.request-failed'))
        .catch(() => this.textMessage.setValue('pa.error-process-request'));
    } else {
      this.textMessage.setValue('pa.request-failed');
    }
  }
}
